import { Component } from '@angular/core';

@Component({
    selector: 'gea-shop-size-guide',
    templateUrl: './size-guide.component.html',
    styleUrls: [],
    standalone: false
})
export class SizeGuideComponent {}
